import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number, CKEditor} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import AppForm from '../../components/AppForm';
import DeleteButton from '../../components/DeleteButton';
import TableForm from '../../components/TableForm';
import ChangeBar from '../../components/ChangeBar';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid),
			dbinfo: state.dbinfo
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);
		this.state = {
			showCC: false,
			showBCC: false,
			showReplyTo: false
		};

		this.api = {
			fetch: 'email.fetch',
			save: 'email.save',
			remove: 'email.delete'
		};
		this.fromInvoice = this.props.tab.args.invoice;
		if (!props.form && this.fromInvoice) {
			this.api.defaults = 'email.getDefaults';
		}
		this.changeEvent = 'email.change';
		this.savePushState = '/email';

		this.messages = {
			remove: 'Opravdu si přejete e-mail odstranit?',
			notfound: 'E-mail nenalezena!'
		};

		this.schema = {
			emailaccount: {
				class: Select,
				label: 'Odesílatel',
				clearable: false,
				value: this.props.dbinfo.emailaccounts[0].id,
				options: this.props.dbinfo.emailaccounts.map((item) => {return {id: item.id, title: item.name + ' <' + item.email + '>'}})
			},
			to: {
				class: TextInput,
				autoFocus: !props.id,
				label: 'Adresát'
			},
			cc: {
				class: TextInput,
				label: 'Kopie'
			},
			bcc: {
				class: TextInput,
				label: 'Skrytá kopie'
			},
			reply_to: {
				class: TextInput,
				label: 'Odpověď'
			},
			subject: {
				class: TextInput,
				label: 'Předmět'
			},
			text: {
				class: CKEditor,
                height: 500
			},
			files: {
				class: FileUpload,
				label: 'Přílohy'
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'subject') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.subject});
	}

	handleShow(e, key) {
		e.preventDefault();
		let s = {};
		s['show' + key] = true;
		this.setState(s);
	}

	save(send) {
		super.save(send, false, {send}, () => {
            if (send) {
                this.context.flashMessage({message: 'E-mail byl odeslán'});
            }
		});
	}

	getDefaultsQuery() {
		return {invoice: this.fromInvoice}
	}


	render() {
		const isNew = !this.props.id;
		const canEdit = 1 || this.user.isAllowed('email', isNew ? 'insert' : 'update');
		const canDelete = 1 || this.user.isAllowed('email', 'delete');

		const saveButton = <Button bsStyle="primary" onClick={()=>this.save(true)} disabled={!canEdit}>
			<i className="fa fa-check position-left"></i>Odeslat
		</Button>;


		const saveAsNewButton = <Button onClick={()=>this.save()} disabled={!canEdit}>
			<i className="fa fa-save position-left"></i>Uložit
		</Button>;

		const deleteButton = this.props.id > 0 && <DeleteButton onClick={()=>this.remove()} />;
		const data = this.form.getValues().toJS();

		return (
			<AppForm id={this.props.tabid} form={this.form} ref="form">
					<Toolbar title="E-mail">
						<ButtonToolbar>
							{canEdit && saveButton}
							{canEdit && saveAsNewButton}
							{canDelete && deleteButton}
						</ButtonToolbar>
					</Toolbar>
				<ChangeBar visible={this.state.showChangedBar} items={this.state.extChangedItems} onAcceptChanges={() => this.acceptChanges()} onClose={() => this.setState({showChangedBar: false})} />
				<div className="row">
						<div className="col-md-12">
							<TableForm>
									<FormRow name="emailaccount" labelWidth={135}/>
									<tr>
										<th>Adresát</th>
										<td>
											<FormField name="to" />
											<div style={{marginTop: 3, fontSize: 12}}>
												{(!this.state.showCC && !data.cc) && <a onClick={(e) => this.handleShow(e, 'CC')} href="#" style={{marginRight:20}}><span className="fa fa-plus position-left"></span>Přidat pole "Kopie"</a>}
												{!this.state.showBCC && !data.bcc && <a onClick={(e) => this.handleShow(e, 'BCC')} href="#" style={{marginRight:20}}><span className="fa fa-plus position-left"></span>Přidat pole "Skrytá kopie"</a>}
												{!this.state.showReplyTo && !data.reply_to && <a onClick={(e) => this.handleShow(e, 'ReplyTo')} href="#" style={{marginRight:20}}><span className="fa fa-plus position-left"></span>Přidat pole "Odpověd"</a>}
											</div>
										</td>
									</tr>
									{(this.state.showCC || (data.cc && data.cc.length > 0)) && <FormRow name="cc" labelWidth={135}/>}
									{(this.state.showBCC || (data.bcc && data.bcc.length > 0)) && <FormRow name="bcc" labelWidth={135}/>}
									{(this.state.showReplyTo || (data.reply_to && data.reply_to.length > 0)) && <FormRow name="reply_to" labelWidth={135}/>}
									<FormRow name="subject" labelWidth={135}/>
							</TableForm>
							<br/>
							<div className="row">
								<div className="col-md-9">
									<FormField name="text" />
								</div>
								<div className="col-md-3">
									<legend>Přílohy</legend>
									<FormField name="files" />
								</div>
							</div>
						</div>
					</div>
			</AppForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Email/Form.js